import styled from '@emotion/styled'

import { DEFAULT_THEME_COLORS, getBodyFonts } from 'css/theme'

export type LabelProps = {
  errored?: boolean
  size?: 'sm' | 'default' | 'lg'
  bold?: boolean
  color?: string
}

const labelStyles = ({ errored, size, bold, color }: LabelProps) => ({
  cursor: 'inherit',
  display: 'flex',
  alignItems: 'center',
  color: color ? color : errored ? DEFAULT_THEME_COLORS['--theme-color--status-error'] : '#504C49',
  ...getBodyFonts(size, bold),
})

const Label = styled.label(labelStyles)

/* For certain accessibility uses we'd rather use a span over a label */
export const SpanLabel = styled.span(labelStyles)

export default Label
